import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Switch, FormControlLabel, Slider } from '@mui/material';

export default function FakeUsersPage() {
  const [stats, setStats] = useState({total:0, active:0, real_users:0, settings:{}, by_lang:[]});
  const [msg, setMsg] = useState('');
  const [removeCount, setRemoveCount] = useState(5);
  const [addCount, setAddCount] = useState(10);
  const tok = localStorage.getItem('dashboard_token');

  const load = () => {
    fetch('/api/fake-users/stats', { headers:{ Authorization:'Bearer '+tok } })
      .then(r=>r.json()).then(d=>setStats(d || {total:0,active:0,real_users:0,settings:{},by_lang:[]}));
  };
  useEffect(() => { load(); }, []);

  const updS = (k, v) => {
    fetch('/api/fake-users/settings', {
      method:'POST',
      headers:{ Authorization:'Bearer '+tok, 'Content-Type':'application/json' },
      body: JSON.stringify({[k]: v})
    }).then(()=>{ setMsg('💾 Збережено'); setTimeout(()=>setMsg(''),2000); load(); });
  };

  const addNow = async () => {
    setMsg('⏳ Додаю...');
    const r = await fetch('/api/fake-users/add?count='+addCount, { method:'POST', headers:{ Authorization:'Bearer '+tok } });
    if(r.ok){ setMsg('✅ Додано '+addCount); setTimeout(()=>setMsg(''),3000); load(); }
  };

  const removeNow = async () => {
    if(!window.confirm('Видалити '+removeCount+' випадкових фейкових?')) return;
    setMsg('⏳ Видаляю...');
    const r = await fetch('/api/fake-users/remove?count='+removeCount, { method:'DELETE', headers:{ Authorization:'Bearer '+tok } });
    if(r.ok){ const d=await r.json(); setMsg('🗑 Видалено '+d.deleted); setTimeout(()=>setMsg(''),3000); load(); }
    else { const d=await r.json().catch(()=>({})); setMsg('❌ Помилка: '+(d.detail||r.status)); setTimeout(()=>setMsg(''),5000); }
  };

  const removeAll = async () => {
    if(!window.confirm('Видалити ВСІХ '+stats.total+' фейкових? Незворотна дія!')) return;
    setMsg('⏳ Видаляю всіх...');
    const r = await fetch('/api/fake-users/remove-all', { method:'DELETE', headers:{ Authorization:'Bearer '+tok } });
    if(r.ok){ const d=await r.json(); setMsg('🗑 Видалено всіх: '+d.deleted); setTimeout(()=>setMsg(''),3000); load(); }
    else { const d=await r.json().catch(()=>({})); setMsg('❌ Помилка: '+(d.detail||r.status)); setTimeout(()=>setMsg(''),5000); }
  };

  const isOn = (k) => stats.settings[k] === 'true';
  const get = (k, def='') => stats.settings[k] || def;

  return (
    <Box sx={{p:3}}>
      <Typography variant="h5" sx={{color:'#FFD700',mb:3}}>🎭 Фейкові юзери</Typography>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #FFD700',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#FFD700',mb:2}}>📊 Поточний стан</Typography>
        <Box sx={{display:'flex',gap:3,flexWrap:'wrap'}}>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Всього фейкових</Typography><Typography sx={{color:'#FFD700',fontSize:32,fontWeight:'bold'}}>{stats.total}</Typography></Box>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Активних</Typography><Typography sx={{color:'#4caf50',fontSize:32,fontWeight:'bold'}}>{stats.active}</Typography></Box>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Реальних</Typography><Typography sx={{color:'#2196f3',fontSize:32,fontWeight:'bold'}}>{stats.real_users}</Typography></Box>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Ціль</Typography><Typography sx={{color:'#fff',fontSize:32,fontWeight:'bold'}}>{get('fake_users_target_count','1000')}</Typography></Box>
        </Box>
        <Box sx={{mt:2}}>
          <Typography sx={{color:'#aaa',fontSize:12,mb:1}}>Розподіл по мовах:</Typography>
          <Box sx={{display:'flex',gap:1,flexWrap:'wrap'}}>
            {stats.by_lang.map(l => (
              <Box key={l.fake_lang} sx={{bgcolor:'#0a0a0a',px:1.5,py:0.5,borderRadius:1,border:'1px solid #555'}}>
                <Typography sx={{color:'#fff',fontSize:13}}>🌐 {l.fake_lang}: {l.cnt}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #4caf50',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#4caf50',mb:2}}>▶ Авто-приріст</Typography>
        <FormControlLabel
          control={<Switch checked={isOn('fake_users_autogrow')} onChange={e=>updS('fake_users_autogrow', e.target.checked ? 'true' : 'false')}/>}
          label={<Typography sx={{color:'#fff'}}>Автоматичне зростання щодня</Typography>}
        />
        <Box sx={{display:'flex',gap:2,mt:2,flexWrap:'wrap'}}>
          <TextField size="small" type="number" label="Мін на день" value={get('fake_users_per_day_min','3')}
            onChange={e=>updS('fake_users_per_day_min', e.target.value)}
            sx={{width:120,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
          <TextField size="small" type="number" label="Макс на день" value={get('fake_users_per_day_max','10')}
            onChange={e=>updS('fake_users_per_day_max', e.target.value)}
            sx={{width:120,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
          <TextField size="small" type="number" label="Цільова кількість" value={get('fake_users_target_count','1000')}
            onChange={e=>updS('fake_users_target_count', e.target.value)}
            sx={{width:160,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
        </Box>
        <Typography sx={{color:'#888',fontSize:12,mt:1}}>Щодня додасться випадкова кількість в межах від мін до макс. Зупиниться при досягненні цілі.</Typography>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #2196f3',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#2196f3',mb:2}}>🏆 Видимість в топах</Typography>
        <FormControlLabel
          control={<Switch checked={isOn('fake_users_show_real_in_top')} onChange={e=>updS('fake_users_show_real_in_top', e.target.checked ? 'true' : 'false')}/>}
          label={<Typography sx={{color:'#fff'}}>Показувати реальних юзерів в топі</Typography>}
        />
        <TextField size="small" type="number" label="Мінімум реальних для показу в топі" value={get('fake_users_min_real_for_top','100')}
          onChange={e=>updS('fake_users_min_real_for_top', e.target.value)}
          sx={{mt:2,width:280,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
        <Typography sx={{color:'#888',fontSize:12,mt:1}}>Реальні юзери з'являться в топі тільки коли їх буде ≥ цього значення І ввімкнено перемикач.</Typography>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #ff9800',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#ff9800',mb:2}}>⚙️ Ручне керування</Typography>
        <Box sx={{display:'flex',gap:2,alignItems:'center',mb:2,flexWrap:'wrap'}}>
          <TextField size="small" type="number" label="Кількість" value={addCount}
            onChange={e=>setAddCount(parseInt(e.target.value)||1)}
            sx={{width:120,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
          <Button variant="contained" onClick={addNow} sx={{bgcolor:'#4caf50'}}>➕ Додати зараз</Button>
        </Box>
        <Box sx={{display:'flex',gap:2,alignItems:'center',flexWrap:'wrap'}}>
          <TextField size="small" type="number" label="Кількість" value={removeCount}
            onChange={e=>setRemoveCount(parseInt(e.target.value)||1)}
            sx={{width:120,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
          <Button variant="contained" onClick={removeNow} sx={{bgcolor:'#f44336'}}>🗑 Видалити випадкових</Button>
        </Box>
        <Box sx={{display:'flex',gap:2,alignItems:'center',mt:1,flexWrap:'wrap'}}>
          <Button variant="outlined" onClick={removeAll} sx={{color:'#f44336',borderColor:'#f44336'}}>
            🗑🗑 Видалити ВСІХ ({stats.total})
          </Button>
        </Box>
      </Paper>

      {msg && <Typography sx={{color: msg.startsWith('❌') ? '#f44336' : '#4caf50',position:'fixed',bottom:20,right:20,bgcolor:'#1a1a2e',p:2,borderRadius:2,zIndex:9999}}>{msg}</Typography>}
    </Box>
  );
}
